import * as React from "react";
import { BaseComponent } from "../../BaseComponent";
import { Icon } from "@fluentui/react";
import { reOrderDotsVerticalIconProps } from "../../../icons/icons.styles";
// Utilities
import { css } from "@fluentui/utilities";
/** Task for converting DndListItem class component to Function component: https://office.visualstudio.com/PathWM/_workitems/edit/8394648 */ /**
 * Abstract Drag and drop list item component.
 * Should be wrapped by a DndList or other DropTarget.
 */ export class DndListItem extends BaseComponent {
    /**
     * Specifies the drag source methods for this component
     */ itemSource() {
        return {
            beginDrag (props) {
                // Return the data describing the dragged item
                return {
                    entity: props.listItem,
                    index: props.index
                };
            }
        };
    }
    /**
     * Specifies which props for react-dnd to inject into this component
     */ itemCollect(connect, monitor) {
        return {
            // Indicates whether the component is being dragged
            isDragging: monitor.isDragging(),
            // This is called in the render method to connect this component to react-dnd drag and drop events
            connectDragSource: connect.dragSource(),
            // Connects this component to the drag preview
            connectDragPreview: connect.dragPreview()
        };
    }
    /**
     * Render the list item
     * @override
     */ renderComponent() {
        const { connectDragSource, connectDragPreview, isReorderDisabled, index, errorMsg, gripperIconProps } = this.props;
        const componentJSX = /*#__PURE__*/ React.createElement("li", {
            ...this.getLiProps(),
            "data-index": index
        }, /*#__PURE__*/ React.createElement("div", {
            className: css("dndListItem", {
                reorderDisabled: isReorderDisabled
            })
        }, /*#__PURE__*/ React.createElement(Icon, gripperIconProps ?? reOrderDotsVerticalIconProps), this.renderListItem()), errorMsg && /*#__PURE__*/ React.createElement("div", {
            className: "errorMessage"
        }, errorMsg));
        const dragSource = connectDragSource && !isReorderDisabled ? connectDragSource(componentJSX) : componentJSX;
        return connectDragPreview ? connectDragPreview(dragSource) : dragSource;
    }
    /**
     * Initializes a new instance of DndListItem
     * @param props Props for the list item control
     * @param context Context to pass onto base component
     */ constructor(props, context){
        super(props, context);
    }
}
